import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useMemo
} from "react";

export interface IPhoneReplyContext {
  replyText: string;
  messageCallContacted: string;
  messageCallType: string;
  selectedToChannelValue: string;
  setReplyText: Dispatch<SetStateAction<string>>;
  setMessageCallContacted: Dispatch<SetStateAction<string>>;
  setMessageCallType: Dispatch<SetStateAction<string>>;
  setSelectedToChannelValue: Dispatch<SetStateAction<string>>;
}

export const PhoneReplyContext = createContext<IPhoneReplyContext | undefined>(
  undefined
);

export interface PhoneReplyProviderProps {
  value: IPhoneReplyContext;
  children: ReactNode;
}

export function PhoneReplyProvider({
  value,
  children
}: PhoneReplyProviderProps) {
  const memoizedValue = useMemo(
    () => value,
    [
      value.replyText,
      value.messageCallContacted,
      value.messageCallType,
      value.selectedToChannelValue,
      value.setReplyText,
      value.setMessageCallContacted,
      value.setMessageCallType,
      value.setSelectedToChannelValue
    ]
  );

  return (
    <PhoneReplyContext.Provider value={memoizedValue}>
      {children}
    </PhoneReplyContext.Provider>
  );
}
export function usePhoneReply(): IPhoneReplyContext {
  const context = useContext(PhoneReplyContext);
  if (context === undefined) {
    throw new Error(
      "usePhoneReply must be used within a PhoneReplyProvider. " +
        "Make sure your component is wrapped with <PhoneReplyProvider>."
    );
  }
  return context;
}

export default PhoneReplyContext;
